import { Controller } from "@hotwired/stimulus"

// Loads available Meta pixels for the selected ad account and populates the dropdown.
// Connected on Step 3 (Customize) of the autoboost wizard.
//
// If adAccountIdValue is set, fetches pixels scoped to that account.
// If not set, fetches ALL pixels for the user via /meta/pixels.json.
export default class extends Controller {
  static targets = ["select", "eventSelect"]
  static values = {
    adAccountId: String,
    selectedPixel: String,
    selectedEvent: String
  }

  connect() {
    console.log("[pixel_selector] connect: adAccountId =", this.adAccountIdValue || "(empty)")
    this.loadPixels()
  }

  async loadPixels() {
    const select = this.selectTarget
    select.innerHTML = '<option value="">Loading pixels...</option>'
    select.disabled = true

    // Use ad-account-scoped endpoint if available, otherwise global endpoint
    const url = this.adAccountIdValue
      ? `/ad-accounts/${this.adAccountIdValue}/pixels.json`
      : `/meta/pixels.json`

    console.log("[pixel_selector] fetching:", url)

    try {
      const response = await fetch(url)
      console.log("[pixel_selector] response status:", response.status)

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const json = await response.json()
      console.log("[pixel_selector] loaded", json.data?.length || 0, "pixels")

      select.innerHTML = '<option value="">No pixel (no conversion tracking)</option>'

      if (json.success && json.data && json.data.length > 0) {
        // Eligible pixels first, then ineligible
        const sorted = [...json.data].sort((a, b) => (b.eligible ? 1 : 0) - (a.eligible ? 1 : 0))
        sorted.forEach(pixel => {
          const option = document.createElement("option")
          option.value = pixel.id
          option.textContent = pixel.eligible === false ? `${pixel.name} (other account)` : pixel.name
          if (pixel.eligible === false) {
            option.disabled = true
            option.classList?.add("text-gray-400")
          }
          if (pixel.id === this.selectedPixelValue) {
            option.selected = true
          }
          select.appendChild(option)
        })
      }
    } catch (e) {
      select.innerHTML = '<option value="">Failed to load pixels</option>'
      console.error("[pixel_selector] Error loading pixels:", e)
    } finally {
      select.disabled = false
    }
  }

  // Show/hide event selector based on pixel selection
  pixelChanged() {
    const hasPixel = this.selectTarget.value !== ""
    if (this.hasEventSelectTarget) {
      this.eventSelectTarget.closest(".pixel-event-wrapper").classList.toggle("hidden", !hasPixel)
    }
  }
}
